(function(angular) {
    'use strict';

    angular.module('nucleus.dashboard')
    .controller('nucleus.dashboard.FirmDashboardController', firmDashboard);
    firmDashboard.$inject = [
        '$scope',
        '$rootScope',
        '$translate',
        '$uibModal',
        '$state',
        '$location',
        '$window',
        'themeData',
        'user',
        'landingPage',
        'nucleus.dashboard.landingPageService',
        'templateList'
    ];

    function firmDashboard(
        $scope,
        $rootScope,
        $translate,
        $uibModal,
        $state,
        $location,
        $window,
        themeData,
        user,
        landingPage,
        landingPageService) {

        /*jshint validthis:true */
        var vm = this;

        vm.companyId = user.companyId;
        vm.contactId = user.contactId;
        vm.lang = user.language;
        vm.backgroundName = 'grass';
        vm.wizardTranslationsLoading = true;
        vm.landingPageTranslationsLoading = true;
        vm.modalCloseWizardModalsConfirmation = undefined;
        vm.helpWidgetVisible = false;
        vm.commonArticlesVisible = false;
        vm.timeRecapWidgetVisible = false;

        vm.myAssignmentWidgetVisible = false;
        vm.myDueDatesWidgetVisible = false;
        vm.myARShortcutsWidgetVisible = false;
        vm.availabilityWidgetVisible = false;
        vm.onvioOverviewVisible = false;
        vm.onvioLearningPortalURL = '';

        if (!landingPage) {
            if (themeData && themeData.header && themeData.header.loginBackground && themeData.header.loginBackground !== '') {
                vm.backgroundName = themeData.header.loginBackground;
            }

            var openCloseWizardModalsConfirmationModal = function openCloseWizardModalsConfirmationModal(nextLocationPath) {
                vm.modalCloseWizardModalsConfirmation = $uibModal.open({
                    animation: true,
                    templateUrl: ('dashboard/close-modals-confirmation-template.html'),
                    size: 'sm',
                    bindToController: true,
                    windowClass: 'close-wizard-modals bmp-confirmation-modal',
                    backdropClass: 'close-wizard-modals-backdrop',
                    controller: ['$scope', '$uibModalStack', '$uibModalInstance', '$location', function controllerFunction($scope, $uibModalStack, $uibModalInstance, $location) {
                        //Remove the first confirmation modal created due to location change triggered twice
                        if (angular.element('.close-wizard-modals').length === 1) {
                            $uibModalInstance.dismiss('cancel');
                            angular.element('.close-wizard-modals').remove();
                        }

                        $scope.closeWizardModals = function closeWizardModals() {
                            $location.path(nextLocationPath);
                            window.dismissLandingPageModal();
                            $uibModalStack.dismissAll();
                        };

                        $scope.cancelCloseWizardModals = function cancelCloseWizardModals() {
                            $location.path('');
                            $uibModalInstance.dismiss('cancel');
                            angular.element('.close-wizard-modals-backdrop').remove();
                        };
                    }]
                }).result.then(function result() { }, function onError(res) {
                    if (!(res === 'cancel' || res === 'escape key press')) {
                        throw res;
                    }
                });
            };

            $rootScope.$on('$locationChangeStart', function locationChangeStart(event, next, current) {
                //If this is not undefined it means the landing page is open
                if (window.dismissLandingPageModal) {
                    //clean this parameters from url
                    var nextParamIndex = next.indexOf('?');
                    if (nextParamIndex !== -1) {
                        next = next.substring(0, nextParamIndex);
                    }
                    var currentParamIndex = current.indexOf('?');
                    if (currentParamIndex !== -1) {
                        current = current.substring(0, currentParamIndex);
                    }

                    //To find out if the next url is the home page
                    var staffPosition = next.indexOf('/staff/#/');
                    var lenghtNextUrl = next.length;
                    var nextIsHomePage = (lenghtNextUrl - staffPosition === 9);
                    //If the next location includes /wsm/ it means that it is a workspace modal fron the setup assistant
                    if (((next !== current) && !next.includes('/wsm/') && !nextIsHomePage)) {
                        var nextLocationPath = $location.path();
                        openCloseWizardModalsConfirmationModal(nextLocationPath);
                        event.preventDefault();
                    }
                }
            });

            if (vm.lang === 'en-US') {
                vm.onvioLearningPortalURL = 'https://training-taxpros.thomsonreuters.com/learn';
            } else {
                vm.onvioLearningPortalURL = 'https://training-taxpros.thomsonreuters.com/learn';
            }

            /*ONVIO SETUP ASSISTANT DEFINITION AND MODALS*/
            $translate([
                'Onvio.SetupAssistant.Definition.SetupTitle',
                'Onvio.SetupAssistant.Definition.NotStarted.LeftTitleBold',
                'Onvio.SetupAssistant.Definition.NotStarted.LeftTitleNormal',
                'Onvio.SetupAssistant.Definition.NotStarted.LeftPanelText',
                'Onvio.SetupAssistant.Definition.NotStarted.LeftButton',
                'Onvio.SetupAssistant.Definition.NotStarted.RightTitle',
                'Onvio.SetupAssistant.Definition.NotStarted.RightText',
                'Onvio.SetupAssistant.Definition.NotStarted.RightLink',
                'Onvio.SetupAssistant.Definition.InProgress.LeftTitleBold',
                'Onvio.SetupAssistant.Definition.InProgress.LeftTitleNormal',
                'Onvio.SetupAssistant.Definition.InProgress.RightTitle',
                'Onvio.SetupAssistant.Definition.InProgress.RightText',
                'Onvio.SetupAssistant.Definition.InProgress.LeftButton',
                'Onvio.SetupAssistant.Definition.InProgress.RightLink',
                'Onvio.SetupAssistant.Definition.InProgress.Required',
                'Onvio.SetupAssistant.Definition.InProgress.Recommended',
                'Onvio.SetupAssistant.Definition.Completed.LeftTitleBold',
                'Onvio.SetupAssistant.Definition.Completed.LeftTitleNormal',
                'Onvio.SetupAssistant.Definition.Completed.RightTitle',
                'Onvio.SetupAssistant.Definition.Completed.RightBoldText',
                'Onvio.SetupAssistant.Definition.Completed.RightText',
                'Onvio.SetupAssistant.Definition.Completed.RightLinkText'
            ]).then(function translations(l10n) {
                vm.wizardTranslationsLoading = false;
                vm.definition = {
                    companyId: user.companyId,
                    application: 'onvio',
                    category: 'onvioSetupCompletion',
                    setupTittle: l10n['Onvio.SetupAssistant.Definition.SetupTitle'],
                    notStarted: {
                        leftTitleBold: l10n['Onvio.SetupAssistant.Definition.NotStarted.LeftTitleBold'],
                        leftTitleNormal: l10n['Onvio.SetupAssistant.Definition.NotStarted.LeftTitleNormal'],
                        leftPanelText: l10n['Onvio.SetupAssistant.Definition.NotStarted.LeftPanelText'],
                        leftButton: l10n['Onvio.SetupAssistant.Definition.NotStarted.LeftButton'],
                        rightTitle: l10n['Onvio.SetupAssistant.Definition.NotStarted.RightTitle'],
                        rightText: l10n['Onvio.SetupAssistant.Definition.NotStarted.RightText'],
                        rightLink: l10n['Onvio.SetupAssistant.Definition.NotStarted.RightLink'],
                    },
                    inProgress: {
                        leftTitleBold: l10n['Onvio.SetupAssistant.Definition.InProgress.LeftTitleBold'],
                        leftTitleNormal: l10n['Onvio.SetupAssistant.Definition.InProgress.LeftTitleNormal'],
                        rightTitle: l10n['Onvio.SetupAssistant.Definition.InProgress.RightTitle'],
                        rightText: l10n['Onvio.SetupAssistant.Definition.InProgress.RightText'],
                        leftButton: l10n['Onvio.SetupAssistant.Definition.InProgress.LeftButton'],
                        rightLink: l10n['Onvio.SetupAssistant.Definition.InProgress.RightLink'],
                        required: l10n['Onvio.SetupAssistant.Definition.InProgress.Required'],
                        recommended: l10n['Onvio.SetupAssistant.Definition.InProgress.Recommended'],
                    },
                    completed: {
                        leftTitleBold: l10n['Onvio.SetupAssistant.Definition.Completed.LeftTitleBold'],
                        leftTitleNormal: l10n['Onvio.SetupAssistant.Definition.Completed.LeftTitleNormal'],
                        rightTitle: l10n['Onvio.SetupAssistant.Definition.Completed.RightTitle'],
                        rightBoldText: l10n['Onvio.SetupAssistant.Definition.Completed.RightBoldText'],
                        rightText: l10n['Onvio.SetupAssistant.Definition.Completed.RightText'],
                        rightLinkText: l10n['Onvio.SetupAssistant.Definition.Completed.RightLinkText'],
                        rightLinkUrl: '#/onvio-setup'
                    }
                };
            });

            vm.evaluateSectionContentChildren = function evaluateSectionContentChildren(sectionContentChildren, sectionIsVisible) {
                sectionContentChildren.forEach(function forEachWidget(widget) {
                    vm.evaluateWidgetContentChildren(widget, sectionIsVisible);
                });
            };

            vm.evaluateWidgetContentChildren = function evaluateWidgetContentChildren(widget, sectionIsVisible) {
                var widgetvisible = sectionIsVisible ? !widget.isHidden : sectionIsVisible;
                if (widgetvisible) {
                    this.appendWidgetSwitch(widget.name);
                }
            };

            vm.appendWidgetSwitch = function appendWidgetSwitch(widgetName) {
                switch (widgetName) {
                    case 'my-due-dates-widget':
                        this.myDueDatesWidgetVisible = true;
                        break;
                    case 'my-ar-shortcuts-widget':
                        this.myARShortcutsWidgetVisible = true;
                        break;
                    case 'availability':
                        this.availabilityWidgetVisible = true;
                        break;
                    case 'my-assignments-widget':
                        this.myAssignmentWidgetVisible = true;
                        break;
                    case 'bm-time-recap-widget':
                        this.timeRecapWidgetVisible = true;
                        break;
                    case 'bm-help-widget':
                        this.helpWidgetVisible = true;
                        break;
                    case 'bm-common-articles':
                        this.commonArticlesVisible = true;
                        break;
                    case 'bm-overview-widget':
                        this.onvioOverviewVisible = true;
                        break;
                    //case 'trial-purchase' / 'setup-module':
                    //There were issues refreshing these components dynamically
                    //Since each of them only does 1 BE call is won't make a performance change if we don't load them dynamycally
                }
                $scope.$apply();
            };

            vm.onDashboardContentInitialized = function onDashboardContentInitialized(eventObj) {
                eventObj.forEach(function forEachSection(section) {
                    vm.evaluateSectionContentChildren(section.contentChildren, section.visible);
                });
            };

            vm.onSectionIsVisible = function onSectionIsVisible(sectionContentChildren) {
                //If this event was triggered means the section is visible now
                vm.evaluateSectionContentChildren(sectionContentChildren, true);
            };

            vm.onWidgetIsVisible = function onWidgetIsVisible(widget) {
                //If this event was triggered means the section is visible now
                vm.evaluateWidgetContentChildren(widget, true);
            };

        }

        //LANDINGPAGE CONFIGURATION

        //Temporary solution for the help link languages - later this should be taken from an endpoint

        if (!vm.lang) {
            vm.lang = 'en-US'; // Default language if user didn't set it yet
        }

        var langCode = vm.lang.slice(3, 5).toLowerCase() + '-' + this.lang.slice(0, 2);
        landingPageService.getDefinition(langCode, user.companyId).then(function(resp) {
            vm.landingPageTranslationsLoading = false;
            vm.landingPageDefinition = resp;
        });

        vm.cancelLandingPageModal = function cancelModal() {
            $window.location.replace('');
        };

        vm.openWorkspaceModal = function openWorkspaceModal(eventObj) {
            switch (eventObj.sectionId) {
                case 'OnvioCenter':
                    {
                        switch (eventObj.value.stepId) {
                            case 'ClientCenter':
                                vm.location = '/staff/#/setup/themes';
                                let modalInstanceClientCenter = $uibModal.open({
                                    animation: true,
                                    templateUrl: ('dashboard/setup-step-modal-client-center.html'),
                                    scope: $scope,
                                    size: 'lg',
                                    bindToController: true,
                                    windowClass: 'setup-step-modal',
                                    backdropClass: 'setup-step-modal-backdrop',
                                    controller: function() {
                                        // Add cancel button
                                        $scope.cancel = function() {
                                            modalInstanceClientCenter.dismiss('cancel');
                                        };
                                        $scope.save = function() {
                                            window.saveSiteSettings();
                                            modalInstanceClientCenter.dismiss('cancel');
                                        };
                                    }
                                });
                                break;
                            case 'PermissionGroups':
                                vm.stepModalUrl = '#/setup/permission-groups';
                                vm.modalTitle = $translate.instant('Onvio.SetupAssistant.Modal.PermissionGroups.Title');
                                vm.location = '/staff/#/setup/permission-groups';
                                let modalInstancePermissionGroups = $uibModal.open({
                                    animation: true,
                                    templateUrl: ('dashboard/setup-step-modal-template.html'),
                                    scope: $scope,
                                    size: 'lg',
                                    bindToController: true,
                                    windowClass: 'setup-step-modal',
                                    backdropClass: 'setup-step-modal-backdrop',
                                    controller: function() {
                                        // Add cancel button
                                        $scope.cancel = function() {
                                            modalInstancePermissionGroups.dismiss('cancel');
                                        };
                                    }
                                });
                                break;
                            case 'ClientNotifications':
                                vm.stepModalUrl = '#/setup/client-notifications';
                                vm.modalTitle = $translate.instant('Onvio.SetupAssistant.Modal.ClientNotifications.Title');
                                vm.location = '/staff/#/setup/client-notifications';
                                let modalInstanceClientNotifications = $uibModal.open({
                                    animation: true,
                                    templateUrl: ('dashboard/setup-step-modal-template.html'),
                                    scope: $scope,
                                    size: 'lg',
                                    bindToController: true,
                                    windowClass: 'setup-step-modal',
                                    backdropClass: 'setup-step-modal-backdrop',
                                    controller: function() {
                                        // Add cancel button
                                        $scope.cancel = function() {
                                            modalInstanceClientNotifications.dismiss('cancel');
                                        };
                                    }
                                });
                                break;
                                case 'TermsAndConditions':
                                    vm.stepModalUrl = '#/setup/terms';
                                    vm.modalTitle = $translate.instant('Onvio.SetupAssistant.Modal.TermsAndConditions.Title');
                                    vm.location = '/staff/#/setup/terms';
                                    let modalInstanceTOS = $uibModal.open({
                                        animation: true,
                                        templateUrl: ('dashboard/setup-step-modal-template.html'),
                                        scope: $scope,
                                        size: 'lg',
                                        bindToController: true,
                                        windowClass: 'setup-step-modal',
                                        backdropClass: 'setup-step-modal-backdrop',
                                        controller: function() {
                                            // Add cancel button
                                            $scope.cancel = function() {
                                                modalInstanceTOS.dismiss('Close');
                                            };
                                        }
                                    });
                                    break;
                            case 'StaffSetup':
                                $state.go('setupAssistantStaff', { notify: false });
                                break;
                            case 'Offices':
                                $state.go('ws-master-detail-offices', { notify: false });
                                break;
                                case 'Firm':
                                    vm.stepModalUrl = '#/setup/firm';
                                    vm.modalTitle = '';
                                    vm.location = '/staff/#/setup/firm';
                                        let modalInstanceFirm = $uibModal.open({
                                            animation: true,
                                            templateUrl: ('dashboard/setup-step-modal-firm.html'),
                                            scope: $scope,
                                            size: 'lg',
                                            bindToController: true,
                                            windowClass: 'setup-step-modal',
                                            backdropClass: 'setup-step-modal-backdrop',
                                            controller: function() {
                                                // Add cancel button
                                                $scope.cancel = function() {
                                                    modalInstanceFirm.dismiss('cancel');
                                                };
                                                $scope.save = function() {
                                                    //send the iframe the action to save
                                                    $scope.$broadcast('save-and-close', {});
                                                };
                                                $scope.openDisplayAsDialog = function() {
                                                    $scope.$broadcast('open-display', {});
                                                };
                                                $scope.$on('show-display-as-link', function(e,showDisplay) {
                                                    $scope.showDisplayAsLink = showDisplay;
                                                });
                                                $scope.$on('changeModalTitle', function(e, title) {
                                                    //after data was loaded on the detail screen the title should change and the header shown
                                                    vm.modalTitle = title;
                                                });
                                                $scope.$on('close-modal', function on() {
                                                    //captures the event
                                                    modalInstanceFirm.close(true);
                                                });
                                                }
                                            });
                                        break;
                            case 'Departments':
                                $state.go('ws-master-detail-departments', { notify: false });
                                break;
                             case 'Learning':
                                $window.open(vm.onvioLearningPortalURL, '_blank');
                                break;
                            case 'ClientSetup':
                                vm.stepModalUrl = '#/setup/clients';
                                vm.modalTitle = '';
                                vm.location = '/staff/#/setup/clients';
                                    let modalInstanceClient = $uibModal.open({
                                        animation: true,
                                        templateUrl: ('dashboard/setup-step-modal-client-setup.html'),
                                        scope: $scope,
                                        size: 'lg',
                                        bindToController: true,
                                        windowClass: 'setup-step-modal',
                                        backdropClass: 'setup-step-modal-backdrop',
                                        controller: function() {
                                                // Add cancel button
                                                $scope.cancel = function() {
                                                    modalInstanceClient.dismiss('cancel');
                                                };
                                            }
                                            });
                                break;
                            case 'FolderTemplate':
                                vm.stepModalUrl = '#/documents/templates';
                                vm.modalTitle = $translate.instant('Onvio.SetupAssistant.Modal.FolderTemplate.Title');
                                vm.location = '/staff/#/setup/documents/templates';
                                    let modalInstanceFolderTemplate = $uibModal.open({
                                        animation: true,
                                        templateUrl: ('dashboard/setup-step-modal-template.html'),
                                        scope: $scope,
                                        size: 'lg',
                                        bindToController: true,
                                        windowClass: 'setup-step-modal',
                                        backdropClass: 'setup-step-modal-backdrop',
                                        controller: function() {
                                            // Add cancel button
                                            $scope.cancel = function() {
                                                modalInstanceFolderTemplate.dismiss('cancel');
                                            };
                                        }
                                    });
                                    break;
                        }
                        break;
                    }
                case 'TimeandBilling':
                    {
                        switch (eventObj.value.stepId) {
                            case 'StaffRate':
                                $state.go('ws-master-detail-employee-rate-descriptions', { notify: false });
                                break;
                            case 'Activities':
                                vm.stepModalUrl = '#/setup/activities';
                                vm.modalTitle = $translate.instant('Onvio.SetupAssistant.Modal.Activities.Title');
                                vm.location = '/staff/#/setup/activities';
                                vm.modalDetailTitle = '';
                                vm.showDetailHeader = false;
                                let modalInstanceActivities = $uibModal.open({
                                    animation: true,
                                    templateUrl: ('dashboard/setup-step-modal-activities.html'),
                                    scope: $scope,
                                    size: 'lg',
                                    bindToController: true,
                                    windowClass: 'setup-step-modal',
                                    backdropClass: 'setup-step-modal-backdrop',
                                    controller: function() {
                                        // Add cancel button
                                        $scope.cancel = function() {
                                            modalInstanceActivities.dismiss('cancel');
                                        };
                                        $scope.cancelDetail = function() {
                                            //send the iframe the action to cancel
                                            $scope.$broadcast('cancel', {});
                                        };

                                        $scope.save = function() {
                                            //send the iframe the action to save
                                            $scope.$broadcast('save-and-close', {});
                                        };

                                        $scope.$on('changeModalTitle', function(e, title) {
                                            //after data was loaded on the detail screen the title should change and the header shown
                                            vm.showDetailHeader = true;
                                            vm.modalDetailTitle = title;
                                        });
                                        $scope.$on('changeModalAction', function(e, isDetailPage) {
                                            vm.showDetailHeader = isDetailPage;
                                        });
                                    }
                                });
                                break;
                            case 'StaffLevels':
                                $state.go('ws-master-detail-employee-levels', { notify: false });
                                break;
                            case 'TaxRates':
                                vm.stepModalUrl = '#/setup/taxrates';
                                vm.modalTitle = $translate.instant('Onvio.SetupAssistant.Modal.TaxRates.Title');
                                vm.location = '/staff/#/setup/taxrates';
                                vm.modalDetailTitle = '';
                                vm.showDetailHeader = false;
                                let modalInstanceTaxRates = $uibModal.open({
                                    animation: true,
                                    templateUrl: ('dashboard/setup-step-modal-taxrates.html'),
                                    scope: $scope,
                                    size: 'lg',
                                    bindToController: true,
                                    windowClass: 'setup-step-modal',
                                    backdropClass: 'setup-step-modal-backdrop',
                                    controller: function() {
                                        // Add cancel button
                                        $scope.cancel = function() {
                                        modalInstanceTaxRates.dismiss('cancel');
                                        };
                                        $scope.cancelDetail = function() {
                                            //send the iframe the action to cancel
                                            $scope.$broadcast('cancel', {});
                                        };

                                        $scope.save = function() {
                                            //send the iframe the action to save
                                            $scope.$broadcast('save-and-close', {});
                                        };

                                        $scope.$on('changeModalTitle', function(e, title) {
                                            //after data was loaded on the detail screen the title should change and the header shown
                                            vm.showDetailHeader = true;
                                            vm.modalDetailTitle = title;
                                        });
                                        $scope.$on('changeModalAction', function(e, isDetailPage) {
                                            vm.showDetailHeader = isDetailPage;
                                        });
                                    }
                                });
                                break;
                            case 'TaxGroups':
                                vm.stepModalUrl = '#/setup/taxgroups';
                                vm.modalTitle = $translate.instant('Onvio.SetupAssistant.Modal.TaxGroups.Title');
                                vm.location = '/staff/#/setup/taxgroups';
                                vm.modalDetailTitle = '';
                                vm.showDetailHeader = false;
                                let modalInstanceTaxGroups = $uibModal.open({
                                    animation: true,
                                    templateUrl: ('dashboard/setup-step-modal-taxgroups.html'),
                                    scope: $scope,
                                    size: 'lg',
                                    bindToController: true,
                                    windowClass: 'setup-step-modal',
                                    backdropClass: 'setup-step-modal-backdrop',
                                    controller: function() {
                                        // Add cancel button
                                        $scope.cancel = function() {
                                            modalInstanceTaxGroups.dismiss('cancel');
                                        };
                                        $scope.cancelDetail = function() {
                                            //send the iframe the action to cancel
                                            $scope.$broadcast('cancel', {});
                                        };

                                        $scope.save = function() {
                                            //send the iframe the action to save
                                            $scope.$broadcast('save-and-close', {});
                                        };

                                        $scope.$on('changeModalTitle', function(e, title) {
                                            //after data was loaded on the detail screen the title should change and the header shown
                                            vm.showDetailHeader = true;
                                            vm.modalDetailTitle = title;
                                        });
                                        $scope.$on('changeModalAction', function(e, isDetailPage) {
                                            vm.showDetailHeader = isDetailPage;
                                        });
                                    }
                                });
                                break;
                            case 'ActivityCategories':
                                $state.go('ws-master-detail-activity-categories', { notify: false });
                                break;
                            case 'EngagementCategories':
                                $state.go('ws-master-detail-engagement-categories', { notify: false });
                                break;
                            case 'StandardText':
                                $state.go('ws-master-detail-standard-texts', { notify: false });
                                break;
                            case 'FixedFeeTemplates':
                                $state.go('ws-master-detail-fixed-fee-billing-templates', { notify: false });
                                break;
                            case 'BankAccounts':
                                $state.go('ws-master-detail-bank-accounts', { notify: false });
                                break;
                            case 'InvoiceAndStatementFormats':
                                vm.stepModalUrl = '#/format-templates';
                                vm.modalTitle = $translate.instant('Onvio.SetupAssistant.Modal.FormatTemplate.Title');
                                vm.location = '/staff/#/format-templates';
                                    let modalInstanceFormatTemplates = $uibModal.open({
                                        animation: true,
                                        templateUrl: ('dashboard/setup-step-modal-formattemplate.html'),
                                        scope: $scope,
                                        size: 'lg',
                                        bindToController: true,
                                        windowClass: 'setup-step-modal',
                                        backdropClass: 'setup-step-modal-backdrop',
                                        controller: function() {
                                            // Add cancel button
                                            $scope.cancel = function() {
                                                modalInstanceFormatTemplates.dismiss('cancel');
                                            };
                                            }
                                        });
                                break;
                        }
                        break;
                    }
                case 'Documents':
                    {
                        switch (eventObj.value.stepId) {
                       //if any card has to be added in documents section add it in steps.it will start appearing //
                        }
                    }
            }
        };

    }
})(window.angular);
